import { Component } from '@angular/core';
import { fadeInOut } from '@shared/animations';

@Component({
  selector: 'sp-spinner',
  template: `
    <div class="overlay" [@fadeInOut]>
      <div class="loader"></div>
    </div>
  `,
  styleUrls: ['./spinner.component.scss'],
  animations: [fadeInOut],
})
export class SpinnerComponent {}
